import { useState, useCallback } from 'react';

const STORAGE_KEY = 'appMode';
const MODES = { LABORATORY: 'laboratory', RADIOLOGY: 'radiology' };

const getInitialMode = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === MODES.RADIOLOGY || stored === MODES.LABORATORY) return stored;
  } catch (e) {
    // localStorage unavailable
  }
  return MODES.LABORATORY;
};

export default function useAppMode() {
  const [mode, setModeState] = useState(getInitialMode);

  const setMode = useCallback((newMode) => {
    if (newMode === MODES.LABORATORY || newMode === MODES.RADIOLOGY) {
      setModeState(newMode);
      try { localStorage.setItem(STORAGE_KEY, newMode); } catch (e) { /* noop */ }
    }
  }, []);

  return {
    mode,
    setMode,
    isLaboratory: mode === MODES.LABORATORY,
    isRadiology: mode === MODES.RADIOLOGY,
  };
}

export { MODES };
